if ($(".article-card").length > 0) {
    $("#clear-search-form").addClass('show');
    $("#GridContent").remove();
}

document.addEventListener('DOMContentLoaded', () => {

    var searchParams = new URLSearchParams(window.location.search);

    var topicName = searchParams.get("topicname");
    var roleName = searchParams.get("rolename");
    var resourceType = searchParams.get("resourcetype");
    var searchTerm = searchParams.get("searchterm");
    var currentPageId = searchParams.get("currentpageid");

    if (topicName || roleName || resourceType || searchTerm || currentPageId) {
        document.querySelector("#query-string-search #submit-button").click();
    }
    
});